import { ReactNode } from "react";

import classnames from "classnames/bind";

import styles from "./Keyboard.module.scss";
import { CharStatus } from "../statuses";
import { GameVisuals } from "../../../gql/graphql";

const cx = classnames.bind(styles);

type Props = {
  children?: ReactNode;
  value: string;
  status?: CharStatus;
  onClick: (value: string) => void;
  theme: GameVisuals;
};

export const Key = ({ children, status, value, onClick, theme }: Props) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    onClick(value);
    event.currentTarget.blur();
  };

  const classes = cx("key", {
    correct: status === "correct",
    present: status === "present",
    absent: status === "absent",
  });

  const backgroundColor = {
    correct: theme.correctLetter,
    present: theme.presentLetter,
    absent: theme.absentLetter,
    default: theme.defaultLetter,
  };

  return (
    <button className={classes} onClick={handleClick} style={{ backgroundColor: backgroundColor[status || "default"] }}>
      {children || value}
    </button>
  );
};
